<script setup lang="ts">
import { useQaEquipmentStore } from '@/stores/qaEquipmentStore.ts';
import QaEquipmentAssignmentRequestDialog from '@/views/qaEquipment/components/QaEquipmentAssignmentRequestDialog.vue';
import QaEquipmentRegistrationDialog from '@/views/qaEquipment/components/QaEquipmentRegistrationDialog.vue';
import QaEquipmentSupportRequestDialog from '@/views/qaEquipment/components/QaEquipmentSupportRequestDialog.vue';
import { useQaEquipmentRegistrationDialog } from '@/views/qaEquipment/utils.ts';
import { watch } from 'vue';

type QaEquipmentRegistrationProps = {
  immediate?: boolean;
};

const props = withDefaults(defineProps<QaEquipmentRegistrationProps>(), {
  immediate: false,
});

const modelValue = defineModel<boolean>({ type: Boolean, default: false });

const qaEquipmentStore = useQaEquipmentStore();

const {
  isRegistrationDialogOpen,
  isAssignmentDialogOpen,
  isSupportDialogOpen,
  requestAssignment,
  requestSupport,
  toggleRegistrationDialog,
} = useQaEquipmentRegistrationDialog(qaEquipmentStore.deviceForRegistration, {
  immediate: props.immediate,
});

watch(modelValue, (modelValueNew) => {
  toggleRegistrationDialog(modelValueNew);
});

watch(isRegistrationDialogOpen, (isRegistrationDialogOpenNew) => {
  modelValue.value = isRegistrationDialogOpenNew;
});
</script>

<template>
  <QaEquipmentRegistrationDialog
    v-model="isRegistrationDialogOpen"
    @click:assignment="requestAssignment"
    @click:support="requestSupport"
  />

  <QaEquipmentAssignmentRequestDialog v-model="isAssignmentDialogOpen" />

  <QaEquipmentSupportRequestDialog v-model="isSupportDialogOpen" />
</template>
